import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestSection() {
  const latestComics = [...comics].sort(() => Math.random() - 0.5).slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="text-xs font-medium text-foreground-500 tracking-widest">
              最新更新
            </span>
            <h3 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
              每日新鲜
            </h3>
            <p className="font-heading text-lg md:text-2xl italic text-foreground-400 mt-1">
              持续上新
            </p>
          </div>
          <Link
            to="/category/healing"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 &rarr;
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop="">
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative rounded-2xl overflow-hidden aspect-[3/4] mb-3 bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title}高清漫画全集免费阅读下拉式 - 178漫画网`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {comic.isNew && (
                  <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-accent-500 text-white text-[10px] font-medium">
                    新作
                  </span>
                )}
                {comic.isHot && (
                  <span className="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-primary-500 text-white text-[10px] font-medium">
                    热门
                  </span>
                )}
                <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/60 to-transparent">
                  <span className="text-white/80 text-[10px]">
                    {comic.updateFrequency}
                  </span>
                </div>
              </div>
              <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {comic.title}
              </h4>
              <p className="text-xs text-foreground-500 mt-1">
                {comic.author} · {comic.category}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}